<template>
  <div class="checkbox-card">
    <label :for="idCheckbox">
      <div class="checkbox-icon">
        <div v-if="checked" class="checbox-check-icon"></div>
      </div>
      <em style="display: none">{{ label }}</em>
    </label>
    <input
      type="checkbox"
      style="display: none"
      :id="idCheckbox"
      :checked="checked"
      @change="$emit('change', $event.target.checked)"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckboxCardReward',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: Boolean,
      require: true,
    },
    idCheckbox: {
      type: [String, Number],
      require: true,
    },
    label: {
      type: String,
      require: true,
    },
  },
};
</script>

<style scope>
.checkbox-card label {
  margin: 0;
}

.checkbox-icon {
  width: 2em;
  aspect-ratio: 1;

  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 12px #00000029;
  border-radius: 6px;
}

.checbox-check-icon {
  width: 100%;
  height: 100%;

  background-image: url('~@/assets/icons/Check.svg');
  background-position: center;
  background-size: 75% 75%;
  background-repeat: no-repeat;
}
</style>
